module.exports = __webpack_public_path__ + "static/media/song2.7d05c96d.jpg";